import React, { useEffect, useState } from "react";
import { useTransition } from "react";
import { fetchAllEventCategories } from "../../Apiservices/Auth/servers/fetchCategoryEvents";
import { useNavigate } from "react-router-dom";

import "../css/Home.css";

function ThurentCategories() {
  const [eventCategories, setEventCategories] = useState([]);
  const [isPending, startTransition] = useTransition();

  const navigate = useNavigate();

  const loadEventCategories = async () => {
    startTransition(async () => {
      const response = await fetchAllEventCategories();
      if (response) {
        // console.log("responseeee",response)
        setEventCategories(response);
      }
    });
  };

  useEffect(() => {
    loadEventCategories();
  }, []);

  return (
    <div className="th-hero flex-column">
      <div className="th-section__category">
        <div className="th-section__container" style={{ textAlign: 'center' }}>
          <span className="th-hero__text th-hero__text__title th-hero__text__sub" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
            Not Sure What Your Event Is?
            <span className="th-hero__text__subtitle" style={{ display: 'inline' }}> Find It Here!</span>
          </span>
          <span className="th-hero__subtext th-hero__subtext__title" style={{ display: 'block', textAlign: 'center', width: '100%', marginTop: '10px' }}>
            Browse event categories to find the perfect match—plan effortlessly
            with our guided solutions.
          </span>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div className="th-section__ev__category__container">
          {isPending ? (
            <h3 style={{ textAlign: "center" }}>
              <i
                className="pi pi-spin pi-spinner-dotted"
                style={{ fontSize: "2rem", color: "#0cc0df" }}
              ></i>
            </h3>
          ) : (
            eventCategories?.map((item) => (
              <div
                key={item.id}
                className="th-section__ev__category__item"
                onClick={() =>
                  navigate(
                    `/event/${item.name?.toLowerCase()?.replaceAll(" ", "-")}`
                  )
                }
              >
                {/* <div
                  className="th-event__category__svg"
                  style={{
                    borderRadius: "8px",
                    background: "#FFF5F4",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="35"
                    viewBox="0 0 32 35"
                    fill="none"
                  >
                    <path
                      d="M19.9177 23.1441C17.7403 20.5359 17.4723 15.1336 17.697 12.1239L24.2942 11.3688C25.1931 14.2499 26.1526 19.5729 24.6207 22.6059C23.7291 24.3713 21.1853 24.6625 19.9177 23.1441Z"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.1005 21.9494C14.3965 19.4448 14.9147 14.0609 14.8299 11.044L8.27473 9.98376C7.24319 12.8201 6.03788 18.093 7.4274 21.1936C8.23625 22.9984 10.7639 23.4074 12.1005 21.9494Z"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.6963 15.3131C19.2415 16.2832 22.9339 18.0483 25.3431 17.3475"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6821 14.2299C13.0937 15.1272 9.32337 16.7192 6.94922 15.9075"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22.4061 24.1136L23.0945 30.1279M25.4126 29.8623L20.7764 30.393"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.53935 22.834L8.59707 28.7788M6.27441 28.4063L10.8812 29.1513"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.6568 8.2782L12.3945 6.90625"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.4404 9.06247L20.9792 8.01013"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.75 7.59215L17.0055 5.74548"
                      stroke="#F7735B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div> */}
                <div className="flex flex-column gap-1"
                style={{width:"100%"}}>
                  <span className="th-plan__text th-line__height"
                   style={{
     display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}>
                    {item.name}
                  </span>
                  {/* <span className="th-event__subtext">
                    {item.shortDescription}
                  </span> */}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ThurentCategories;
